import React, { useState } from "react";
import { LuArrowLeft } from "react-icons/lu";
import { colors } from "./constants";

export function BackButton({ onClick, title = "Back" }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      title={title}
      aria-label={title}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "#f1f5f9" : "none",
        border: "none",
        borderRadius: "6px",
        padding: "6px",
        cursor: "pointer",
        color: colors.text,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.15s",
      }}>
      <LuArrowLeft size={20} />
    </button>
  );
}
